import { Button, Switch, Table, TableContainer, Tbody, Td, Th, Thead, Tr, useToast, Divider, FormControl, FormLabel, Heading, Input, Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay, useDisclosure, } from "@chakra-ui/react";
import axios from "axios";
import { useEffect, useState } from "react";
import { ChatState } from "../../../Context/ChatProvider";


const GroupTable = ({ data, search, loading, setFetchAgain }) => {
	const { isOpen, onOpen, onClose } = useDisclosure()

	const [id, setId] = useState("");
	const [groupName, setGroupName] = useState("");
	const [level, setLevel] = useState('');
	const [teacher, setTeacher] = useState("");
	const [groupType, setGroupType] = useState("");
	const [numberOfStudents, setNumberOfStudents] = useState("");
	const [picLoading, setPicLoading] = useState(false);


	const { user } = ChatState();

	const toast = useToast();

	const [fetchLevelAgain, setFetchLevelAgain] = useState(true);
	const [levelTable, setLevelTable] = useState([]);
	const [teacherTable, setTeacherTable] = useState([]);

	useEffect(() => {
		if (user != undefined) {
			getAllLevels();
			getAllTeachers();
			setFetchLevelAgain(false);
		}
	}, [fetchLevelAgain === true || user != undefined])

	async function getAllLevels() {
		try {
			setLevelTable([])

			const config = {
				headers: {
					Authorization: `Bearer ${user.token}`,
				},
			};
			const { data } = await axios.get(`/api/level`, config)



			setLevelTable(data)



		} catch (error) {
			toast({
				title: "Une erreur s'est produite !",
				description: "Échec du chargement des résultats de recherche",
				status: "error",
				duration: 5000,
				isClosable: true,
				position: "bottom-left",
			});
		}
	}
	async function getAllTeachers() {
		try {
			setLevelTable([])

			const config = {
				headers: {
					Authorization: `Bearer ${user.token}`,
				},
			};
			const { data } = await axios.get(`/api/teacher`, config)



			setTeacherTable(data)



		} catch (error) {
			toast({
				title: "Une erreur s'est produite !",
				description: "Échec du chargement des résultats de recherche",
				status: "error",
				duration: 5000,
				isClosable: true,
				position: "bottom-left",
			});
		}
	}
	const openModal = (groupInfo) => {
		setId(groupInfo ? groupInfo._id : "")
		setGroupName(groupInfo ? groupInfo.groupName : "");
		setLevel(groupInfo ? groupInfo.level : "");
		setTeacher(groupInfo ? groupInfo.teacher : "");
		setGroupType(groupInfo ? groupInfo.groupType : "");
		setPicLoading(false);
		onOpen()
	}


	const deleteGroup = async (id) => {


		try {
			const config = {
				headers: {
					"Content-type": "application/json",
					Authorization: `Bearer ${user.token}`,
				},
				params: { id: id }

			};

			await axios.delete(
				'/api/group',
				config
			);

			toast({
				title: "Supprimé avec succès",
				status: "success",
				duration: 5000,
				isClosable: true,
				position: "bottom",
			});
			setFetchAgain(true);
		} catch (error) {
			toast({
				title: "Une erreur s'est produite !",
				description: error.response.data.message,
				status: "error",
				duration: 5000,
				isClosable: true,
				position: "bottom",
			});
		}
	}



	const updateGroup = async () => {
		if (!groupName || !level || !teacher || !groupType) {
			toast({
				title: "Veuillez remplir tous les champs",
				status: "warning",
				duration: 5000,
				isClosable: true,
				position: "bottom",
			});
			setPicLoading(false);
			return;
		}
		setPicLoading(true);

		try {
			const config = {
				headers: {
					"Content-type": "application/json",
					Authorization: `Bearer ${user.token}`,
				},
			};
			await axios.put(
				"/api/group",

				{
					id,
					groupName,
					level,
					teacher,
					groupType,
					numberOfStudents
				},
				config
			);

			toast({
				title: "Mise à jour réussie",
				status: "success",
				duration: 5000,
				isClosable: true,
				position: "bottom",
			});



			setFetchAgain(true);



		} catch (error) {
			toast({
				title: "Une erreur s'est produite !",
				description: error.response.data.message,
				status: "error",
				duration: 5000,
				isClosable: true,
				position: "bottom",
			});

		}
		onClose();
	};


	return (
		<>
			{/* <Button ml={4} ref={finalRef}>
        I'll receive focus on close
    </Button> */}

			<Modal
				//initialFocusRef={initialRef}
				// finalFocusRef={finalRef}
				isOpen={isOpen}
				onClose={onClose}
			>
				<ModalOverlay />
				<ModalContent m='auto'>
					<ModalHeader className="bg-gray-50 shadow-md text-black text-xl"><i className="fa-solid fa-users-line text-2xl mr-2"></i>Group</ModalHeader>
					<ModalBody pb={6}>


						<div className="mr-4">


							<FormControl mt={4}>
								<Input placeholder='Nom du groupe' id='groupeName' value={groupName}
									onChange={(e) => setGroupName(e.target.value)} />
							</FormControl>

							<FormControl mt={4}>
								<select defaultValue={level !== '' ? level : "def"} className="w-full border p-2" onChange={(e) => { setLevel(e.target.value) }}>
									<option value="def" defaultChecked disabled>Choiser un Niveaux</option>
									{
										levelTable.map((level) => {
											return <option value={level.levelName}>{level.levelName}</option>
										})
									}
								</select>
							</FormControl>

							<FormControl mt={4}>

								<select defaultValue={teacher !== "" ? teacher : "def"} className="w-full border p-2" onChange={(e) => { setTeacher(e.target.value) }}>
									<option value="def" defaultChecked disabled>Choiser un Professeur</option>
									{
										teacherTable.map((teacher) => {
											return <option value={teacher.teacherName}>{teacher.teacherName}</option>
										})
									}
								</select>
							</FormControl>
							<FormControl mt={4}>

								<select defaultValue={groupType !== "" ? groupType : "def"} className="w-full border p-2" onChange={(e) => { setGroupType(e.target.value) }}>
									<option value="def" defaultChecked disabled>Choiser un Type</option>
									<option value="Présentiel">Présentiel</option>
									<option value='Hybride'>Hybride</option>
								</select>
							</FormControl>





						</div>


					</ModalBody>

					<ModalFooter>
						<Button colorScheme='blue' mr={3}
							onClick={updateGroup}
							isLoading={picLoading}>
							Enregistrer
						</Button>
						<Button onClick={onClose}>Annuler</Button>
					</ModalFooter>
				</ModalContent>
			</Modal>
			<TableContainer w={"full"} className='border'>
				<Table variant={"simple"} >

					<Thead>
						<Tr className="bg-gray-50 text-black">
							<Th textAlign={"center"}>Group</Th>
							<Th textAlign={"center"}>Niveaux</Th>
							<Th textAlign={"center"}>Professeur</Th>
							<Th textAlign={"center"}>Type</Th>
							<Th textAlign={"center"}>Nombre d'étudiants</Th>
							<Th w={"24"}></Th>
						</Tr>
					</Thead>
					<Tbody >

						{data?.filter((group) => {
							return search.toLowerCase() === ''
								? group
								: group.groupName.toLowerCase().includes(search.toLowerCase());
						})
							.map((group, index) => (

								<Tr key={index} fontSize="sm">
									<Td textAlign={"center"}>{group.groupName}</Td>
									<Td textAlign={"center"}>{group.level}</Td>
									<Td textAlign={"center"}>{group.teacher}</Td>
									<Td textAlign={"center"}>{group.groupType}</Td>
									<Td textAlign={"center"}>{group.numberOfStudents}</Td>

									<Td >

										<Button bg='gray.50' onClick={() => { openModal(group) }}> <i className="fa-regular fa-pen-to-square text-blue-400 mr-2"></i> Modifier
										</Button>

										<Button fontSize={14} ml={2} bg='gray.50' onClick={() => deleteGroup(group._id)}  ><i className="fa-solid fa-trash text-red-500"></i></Button>
									</Td>
								</Tr>

							))}


					</Tbody>


				</Table>
				<div className="w-full  flex item-center p-6">
					{loading && <i className="fa-solid fa-circle-notch animate-spin m-auto text-xl"></i>}
					{!loading && data.length === 0 && <span className="text-md text-gray-300 m-auto">Aucun résultat.</span>}
				</div>
			</TableContainer>
		</>
	);


};

export default GroupTable;
